import BasicPieChart from "../charts/BasicPieChart";

const data = [
  {
    variant: "danger",
    color: "rgb(230, 83, 60)",
    name: "Fradulent Apps",
    value: 212,
  },
  {
    name: "Other Apps",
    value: 500,
    variant: "warning",
    color: "rgb(245, 184, 73)",
  },
];

const FraudWidget = () => {
  return (
    <div>
      <div className="card custom-card">
        <div className="card-header justify-content-between">
          <div className="card-title">Fraud Analysis</div>
        </div>
        <div className="card-body">
          <div className="d-flex align-items-center mb-3">
            <h4 className="fw-bold mb-0 me-2">85</h4>
            <span className="text-muted">
              total apps identified as fraudulent
            </span>
          </div>

          <div className="d-flex justify-content-center">
            <BasicPieChart data={data} />
          </div>

          <ul className="list-unstyled mb-0 pt-2 crm-deals-status">
            {data?.map((item, x) => (
              <li className={item.variant} key={x}>
                <div className="d-flex align-items-center justify-content-between">
                  <div>{item?.name}</div>
                  <div className="fs-12 text-muted">{item?.value} apps</div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

FraudWidget.propTypes = {};

export default FraudWidget;
